import { css } from 'styled-components';

export const flexCenter = css`
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
`;
